import find from 'lodash/find';
import map from 'lodash/map';
import findLast from 'lodash/findLast';



export function moveHotkey(arr, from, to) {
  if (from === to) {
    return arr;
  }

  const { position: sPos, key: sKey, active: sActive = false } = find(arr, { key: from }) || {};
  const { position: tPos, active: tActive = false } = find(arr, { key: to }) || {};

  if (!sActive || !tActive) {
    return arr;
  }

  const getPosition = getPositionUpdater(sKey, sPos, tPos);

  return arr.map(e => {
    const { position: ePos, key: eKey } = e;
    return {
      ...e,
      position: getPosition(eKey, ePos)
    }
  });
}




export function insertHotkeys(arr, ...hotkeys) {
  return (hotkeys || []).reduce((newArr, hotkey) => {
    const { position: hPos, key: hKey } = hotkey;
    const { position: tPos } = find(newArr, h => !h.active && !h.deleted);

    const getPosition = getPositionUpdater(hKey, hPos, tPos);

    return (newArr.concat(hotkey) || []).map(e => {
      const { position: ePos, key: eKey } = e;

      return {
        ...e,
        position: getPosition(eKey, ePos)
      }
    });
  }, arr);
}




export function deleteHotkeyMark(arr, hotkey) {
  const { key: hKey, position: hPos } = hotkey;
  const getPosition = getPositionUpdater(hKey, hPos, arr.length - 1);

  return (arr || []).map(e => {
    const { key: eKey, position: ePos } = e;

    return (hKey !== eKey) 
            ? {
                ...e,
                position: getPosition(eKey, ePos)
              }
            : {
                ...e,
                position: getPosition(eKey, ePos),
		            disabled: true,
                deleted: 1
              }
  });
}




export function deleteHotkeyPerm(arr, hotkey) {
  const { key: hKey, position: hPos } = hotkey;
  const getPosition = getPositionUpdater(hKey, hPos, arr.length - 1);

  return (arr || []).reduce((res, e) => {
    const { key: eKey, position: ePos } = e;

    return (hKey === eKey) 
            ? res
            : res.concat({
		            ...e,
		            position: getPosition(eKey, ePos)
	            })
  }, []);
}




export function toggleHotkeyActive(arr, hotkey) {
  const { position: sPos, key: sKey, active: sActive } = hotkey;  
  const { position: tPos } = (!sActive)
                              ? find(arr, h => !h.active && !h.deleted) 
                              : findLast(arr, h => h.active && !h.deleted);

  const getPosition = getPositionUpdater(sKey, sPos, tPos);

  return map(arr, e => {
    const { position: ePos, key: eKey, active: eActive } = e;

    return {
      ...e,
      position: getPosition(eKey, ePos),
      active: (eKey !== sKey) ? eActive : !eActive
    };
  });
}




export function replaceHotkey(arr, hotkey) {
  const { key: hKey } = hotkey;
  return map(arr, e => {
    const { key: eKey } = e;

    return (hKey !== eKey)
            ? e
            : hotkey;
  });
}




function getPositionUpdater(sKey, sPos, tPos) {
  return (eKey, ePos) => {
    if (eKey === sKey) {
      return tPos;
    }
    
    if (
      tPos > sPos
      && (ePos <= tPos && ePos > sPos)
    ) {
      return ePos - 1;
    }

    if (
      ePos >= tPos
      && ePos < sPos
    ) {
      return ePos + 1
    }

    return ePos;
  }
}
